module.exports = __webpack_public_path__ + "static/media/insurance_icon.329747e2.svg";